import React, { useEffect, useState, useRef, useContext } from "react";
import FileIcon from "../File/file";
import Info from "../Info/info";
import InfoTitle from "../Info/InfoTitle";
import styles from "./styles/new_beneficiary.module.css";
import Upload from "../Upload/upload";
import PhoneInput from "react-phone-input-2";
import fr_phone_countries from "react-phone-input-2/lang/fr.json";
import "./styles/phone.css";
import { Switch } from "@mui/material";
import { Beneficiarytrustee } from "../Beneficiarytrustee/Beneficiarytrustee";
import PartnerSharingPerson, {
  EMPTY_PERSON_SHARING,
  personSharingValue,
} from "../Partner Sharing/PartnerSharingPerson";
import { getPartner } from "../Partner Sharing/PartnerSharing";
import { encryptBeneficiary } from "../../../Utils/dataEncryption";
import AssetType from "../Asset Type/AssetType";
import AddNewAsset from "./AddNewAsset";
import AddBeneficiary from "../Add Asset/AddBeneficiary";
import { UserData } from "../../../Context/DataContext";
import { GenerateID, RandomId } from "../../../Utils/RandomId";
import { useScrollLock } from "../../../Utils/useScrollLock";
import { UploadFiles, downloadLocalFile } from "../../../Utils/UploadFile";
import SHA from "sha.js";
import {
  encryptFileAES,
  encryptText,
  pbdkf2,
} from "../../../Utils/OstreonEncryption";
import config from "../../../config";
import { generateCode } from "../../../Utils/personalCode";
import { OnProgress } from "../My Account/OnProgress";
import { handleIssues } from "../../../Utils/handleIssues";
import CCCalendar from "../CC Calendar/CCCalendar";
import { isValidDateFormat } from "../../../Utils/isValidDateFormat";
import { isValidFileSize } from "../../../Utils/isValidFileSize";
import { createAccess, sendEmail } from "../../../Utils/beneficiary";
import { buildPrivateKey } from "../../../Utils/beneficiaryUtils";
import {
  RELATIONSHIP_OPTIONS,
  ADDED_FIELDS,
  isMinor,
} from "../../../Utils/minorBeneficiary";
import { floatMessage } from "../../../Utils/floatMessage";
import parse from "html-react-parser";
import { useAuth } from "../../../Context/AuthContext";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import uploadButton from "./styles/img/upload_button.png";
import editButton from "./styles/img/edit_button.svg";
import { Upload as UploadProfilePicture } from "antd";
import CropperImage from "antd-cropper-img";
import { DeleteOutlined, DownOutlined } from "@ant-design/icons";
import { encodeFileToBase64 } from "../../../Utils/encodeFile";
import useWindowDimensions from "../../Footer/footer";
import plus_button from "./styles/img/plus_button.svg";

import { NewEmailField } from "./newEmailField";
const base_url = config.base_url;
function NewBeneficiary({ onClose, priority = 1 }) {
  const [showTopShadow, setShowTopShadow] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const divElementRef = useRef(null);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const { height, width } = useWindowDimensions();
  const [openPersonalMessage, setOpenPersonalMessage] = useState(false);

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AddBeneficiary.NewBeneficiary
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AddBeneficiary.NewBeneficiary);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [previewImage, setPreviewImage] = useState(null);
  const [image, setImage] = useState(null);
  useEffect(() => {
    const divElement = divElementRef.current;

    const handleScroll = () => {
      const scrollTop = divElement.scrollTop;
      const scrollHeight = divElement.scrollHeight;
      const clientHeight = divElement.clientHeight;
      setShowTopShadow(scrollTop > 0);
      setShowBottomShadow(scrollTop + clientHeight < scrollHeight - 10);
    };

    // Call handleScroll once on initial load to set shadows
    handleScroll();

    divElement.addEventListener("scroll", handleScroll);

    return () => {
      divElement.removeEventListener("scroll", handleScroll);
    };
  }, [height]);

  const [files, setFiles] = useState([]);
  const [modal, setModal] = useState();
  const userData = UserData();
  const auth = useAuth();
  const index_ = userData?.UserData?.beneficiaries.map((beneficiary) => {
    return beneficiary.user_id;
  });
  const customer_id = userData?.UserData?.user_id;
  const [beneficiary, setBeneficiary] = useState({
    user_id: GenerateID(customer_id, "B", index_),
    name: "",
    priority: String(priority),
    message: "",
    email: "",
    // TODO: un-comment this field for adding multipe benef. emails
    email_2: "",
    email_3: "",
    phone_number: "",
    awareness_status: "false",
    // TODO: un-comment this field for adding multipe benef. emails
    awareness_status_2: "false",
    awareness_status_3: "false",
    status: false,
    birth_date: "",
    personal_documents: [],
    visible_assets: [],
    trustees: [],
    profile_avatar: null,
    personal_code: generateCode(),
    // is_minor and relationship; a minor uses the same contact fields as anyone.
    ...ADDED_FIELDS,
    /*
      Partner sharing, off for both. They live on the beneficiary rather than in
      their own state because encryptBeneficiary spreads the whole object and
      they are stored unencrypted -- the server has to be able to read them to
      decide what a partner may be sent.
    */
    ...EMPTY_PERSON_SHARING,
  });
  /*
    Null when this user has no partner, which is what hides the section --
    there is nothing for it to say. See getPartner.
  */
  const partner = getPartner(userData);
  const minor = isMinor(beneficiary);
  const [error, setError] = useState({
    name: "",
    priority: "",
    email: "",
    // TODO: un-comment this field for adding multipe benef. emails
    email_2: "",
    email_3: "",
    phone_number: "",
    birth_date: "",
    message: "",
    personal_documents: "",
    file_size: "",
  });
  const [benefEmailFields, setBenefEmailFields] = useState([]);
  const [duplicatedName, setDuplicatedName] = useState(false);
  const duplicateError = content.newBeneficiaryText1;
  const maxFilesToUpload = "8";
  // textarea
  const maxMessageLength = 10000; // Define the maximum character length for the message field

  const textareaRef = useRef(null);

  const handleChangeDescription = () => {
    const textarea = textareaRef.current;
    // Reset the textarea height to 0 to correctly calculate the scrollHeight
    textarea.style.height = "0";
    const height = textarea.scrollHeight;
    textarea.style.height = `${height}px`;
  };

  const Progress = (status) => {
    setModal(
      <OnProgress title={dublicatedcontent?.work_in_progress} status={status} />
    );
  };
  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validateData = () => {
    var errors_ = {};
    var isError = false;
    if (validateBeneficiaryAmount(beneficiary.priority)) {
      errors_["priority_amount"] = content.newBeneficiaryError1;
      isError = true;
    }

    if (!isValidEmail(beneficiary.email)) {
      errors_["email"] = dublicatedcontent.dublicatedText47;
      isError = true;
    }

    // TODO: un-comment this field for adding multipe benef. emails
    if (!isValidEmail(beneficiary.email_2) && benefEmailFields.length > 0) {
      errors_["email_2"] = dublicatedcontent.dublicatedText47;
      isError = true;
    }
    if (
      isValidEmail(beneficiary.email_2) &&
      benefEmailFields.length > 0 &&
      beneficiary.email_2 === beneficiary.email
    ) {
      errors_["email_2"] = dublicatedcontent.dublicatedText281;
      isError = true;
    }

    if (benefEmailFields.length > 1 && !isValidEmail(beneficiary.email_3)) {
      errors_["email_3"] = dublicatedcontent.dublicatedText47;
      isError = true;
    }
    if (
      benefEmailFields.length > 1 &&
      isValidEmail(beneficiary.email_3) &&
      (beneficiary.email_3 === beneficiary.email_2 ||
        beneficiary.email_3 === beneficiary.email)
    ) {
      errors_["email_3"] = dublicatedcontent.dublicatedText281;
      isError = true;
    }

    if (beneficiary.name === "") {
      errors_["name"] = content.newBeneficiaryError3;
      isError = true;
    }

    // check if beneficiary with this name is exist
    if (userData.UserData.beneficiaries.length && beneficiary.name !== "") {
      const newBenName = beneficiary.name;
      let hasMatchingBen = userData.UserData.beneficiaries.some(
        (benItem) => benItem.name.toLowerCase() === newBenName.toLowerCase()
      );

      if (hasMatchingBen) {
        isError = true;
        setDuplicatedName(true);
        document.getElementById("scrollContainer").scrollTop = 0;
      }
    }

    if (beneficiary.last_name === "") {
      errors_["last_name"] = content.newBeneficiaryError4;
      isError = true;
    }
    if (!isValidDateFormat(beneficiary.birth_date)) {
      errors_["birth_date"] = dublicatedcontent.dublicatedText48;
      isError = true;
    }
    if (beneficiary.priority === "") {
      errors_["priority"] = content.newBeneficiaryError6;
      isError = true;
    }
    if (beneficiary.message.length > maxMessageLength) {
      errors_["message"] = content.newBeneficiaryError7;
      isError = true;
    }
    if (beneficiary.personal_documents.length > maxFilesToUpload) {
      errors_["personal_documents"] = content.newBeneficiaryError8;
      isError = true;
    }

    setError(errors_);
    setTimeout(() => {
      setError({
        name: "",
        priority: "",
        email: "",
        // TODO: un-comment this field for adding multipe benef. emails
        email_2: "",
        email_3: "",
        phone_number: "",
        last_name: "",
        birth_date: "",
        message: "",
        personal_documents: "",
        priority_amount: "",
        file_size: "",
      });
    }, 5000);
    return isError;
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (validateData()) {
      return;
    }

    /*
      A partner adding a beneficiary to their customer's account.

      Deliberately an early return rather than a branch threaded through what
      follows, because almost none of what follows may happen. This beneficiary
      does not exist yet as far as the mechanism is concerned: no login account
      is created for them, no awareness email is sent, no profile picture is
      uploaded and the customer's status does not change. All of that waits for
      the customer to approve, which is the whole meaning of pending.

      The record is encrypted under the CUSTOMER's key --  is
      theirs inside this view -- so the server stores ciphertext it cannot read,
      exactly as it does for the customer's own writes.
    */
    if (userData.partnerCreate) {
      Progress(content.newBeneficiaryText2);
      const encrypted = await encryptBeneficiary(
        { ...beneficiary, profile_avatar: null },
        userData.private_key
      );
      /*
        The progress modal is cleared whatever happens. Left up on failure it
        reads as a save still running, and the partner waits on something that
        already finished -- which is exactly what a rejected record did.
      */
      let result;
      try {
        result = await userData.partnerCreate("beneficiary", encrypted);
      } finally {
        setModal(null);
      }
      if (result?.ok) {
        floatMessage(dublicatedcontent?.saved);
        onClose();
      } else {
        floatMessage(
          result?.detail ||
            dublicatedcontent?.an_error_occured_try_later ||
            "Something went wrong"
        );
      }
      return;
    }

    var new_assets = [...userData.UserData.assets];
    beneficiary.visible_assets.map((beneficiary_asset_id) => {
      new_assets.map((asset, index) => {
        if (beneficiary_asset_id === asset.asset_id) {
          new_assets[index].beneficiaries = [
            ...new Set([...asset.beneficiaries, beneficiary.user_id]),
          ];
        }
        return null;
      });
      return null;
    });

    UploadFiles(files, userData.private_key, Progress, dublicatedcontent)
      .then(async () => {
        Progress(content.newBeneficiaryText2);
        var new_issues = handleIssues(
          {
            ...userData.UserData,
            beneficiaries: [...userData.UserData.beneficiaries, beneficiary],
            assets: new_assets,
          },
          userData.BillingData
        );

        userData.Update(RandomId(10));

        floatMessage(dublicatedcontent?.saved);
        userData.setCustomerUser({
          ...userData.CustomerUser,
          user_status: new_assets.some((e) => e.beneficiaries.length > 0)
            ? "Active"
            : "Inactive",
        });
        const beneficiary_accesses = await Promise.all([
          buildPrivateKey(
            userData.private_key,
            beneficiary?.email,
            beneficiary?.birth_date,
            beneficiary?.personal_code
          ),
          beneficiary?.email_2
            ? buildPrivateKey(
                userData.private_key,
                beneficiary?.email_2,
                beneficiary?.birth_date,
                beneficiary?.personal_code
              )
            : undefined,
          beneficiary?.email_3
            ? buildPrivateKey(
                userData.private_key,
                beneficiary?.email_3,
                beneficiary?.birth_date,
                beneficiary?.personal_code
              )
            : undefined,
        ]);
        const body = {
          email: beneficiary.email,
          beneficiary_user_id: beneficiary.user_id,
          accesses: beneficiary_accesses,
        };
        createAccess(body, "add")
          .then((res) => {
            let beneficiary_emails = [];
            if (beneficiary.awareness_status === "true")
              beneficiary_emails.push(beneficiary?.email);
            if (beneficiary.awareness_status_2 === "true")
              beneficiary_emails.push(beneficiary?.email_2);
            if (beneficiary.awareness_status_3 === "true")
              beneficiary_emails.push(beneficiary?.email_3);
            if (beneficiary_emails.length > 0) {
              sendEmail(beneficiary, "beneficiary", beneficiary_emails);
              auth.setAwarenessEmail(auth.awareness_email + 1);
            }
            return;
          })
          .then(async (res) => {
            console.log(res);
            if (!image) return;
            const formData = new FormData();
            const encrypted_image = await encryptFileAES(
              userData.private_key,
              image
            );
            formData.append("file", encrypted_image);
            formData.append("profile_id", beneficiary?.user_id);
            return fetch(base_url + "user/profile/pic/upload", {
              method: "POST",
              mode: "cors",
              body: formData,
              credentials: "include",
            });
          })
          .then(async (res) => {
            let benefAvatar = null;
            try {
              if (image) benefAvatar = await encodeFileToBase64(image);
            } catch (error) {
              benefAvatar = null;
            }
            userData.setCustomerBeneficiary((prev) => {
              return [
                ...prev,
                {
                  status: "inactive",
                  user_id: beneficiary.user_id,
                  profile_avatar: benefAvatar?.base64String || null,
                },
              ];
            });

            userData.setUserData({
              ...userData.UserData,
              beneficiaries: [
                ...userData.UserData.beneficiaries,
                {
                  ...beneficiary,
                  profile_avatar: benefAvatar?.base64String || null,
                },
              ],
              assets: new_assets,
              issues: new_issues,
            });
            setModal(null);
            onClose();
            // await userData.getCustomerBeneficiary();
            setPreviewImage(null);
            setImage(null);
          });
      })
      .catch((e) => {
        // Progress(e);
        setTimeout(() => {
          setModal(null);
          onClose();
        }, 1000);
      });
  };

  const [needToClear, setNeedToClear] = useState(false);

  const handleFile = (e) => {
    const file_array = Array.from(e.target.files);

    // show error if one of loaded files is more than 100mb
    const sizeError = isValidFileSize(file_array);
    if (sizeError) {
      setError({
        file_size: parse(sizeError),
      });
      setTimeout(() => {
        setError({
          file_size: "",
        });
      }, 10000);
      setNeedToClear(true);
      return;
    }

    const filesFreeSlots = maxFilesToUpload - files.length;
    if (
      file_array.length > maxFilesToUpload ||
      filesFreeSlots < file_array.length
    ) {
      setError({
        personal_documents: `${
          content.newBeneficiaryText3
        } ${maxFilesToUpload} ${dublicatedcontent?.dublicatedText94?.toLowerCase()}`,
      });
      setTimeout(() => {
        setError({
          personal_documents: "",
        });
      }, 5000);
      return;
    }

    let asset_files = [];
    file_array.map((newFile) => {
      console.log(newFile);
      let asset_file = {
        id: RandomId(32),
        name: newFile.name,
        size: newFile.size,
        lastModified: newFile.lastModified,
      };
      asset_files.push(asset_file);
      let newBlob = new Blob([newFile], {
        type: newFile.type,
        lastModified: newFile.lastModified,
      });
      let renamedFile = new File([newBlob], asset_file.id, {
        type: newFile.type,
      });
      setFiles((files) => [...files, renamedFile]);
      return null;
    });
    setBeneficiary({
      ...beneficiary,
      personal_documents: beneficiary.personal_documents.concat(asset_files),
    });
  };
  const deleteFile = (fileO) => {
    const new_files = files.filter((file) => file.name !== fileO.id);
    setFiles(new_files);
    console.log(new_files);
    setBeneficiary({
      ...beneficiary,
      personal_documents: beneficiary.personal_documents.filter(
        (file) => file.id !== fileO.id
      ),
    });
  };

  const customerBeneficiaries = UserData().UserData.beneficiaries;

  const priorityOneAmount = customerBeneficiaries.filter(
    (item) => item.priority === "1"
  );
  const priorityTwoAmount = customerBeneficiaries.filter(
    (item) => item.priority === "2"
  );

  const validateBeneficiaryAmount = (priority) => {
    let filteredItems;
    if (priority) {
      filteredItems = customerBeneficiaries.filter(
        (item) => item.priority === priority
      );
    } else {
      filteredItems = customerBeneficiaries.filter(
        (item) => item.priority === "1"
      );
    }

    if (filteredItems.length >= 6) {
      setError({
        priority_amount: content.newBeneficiaryText4,
      });
      setTimeout(() => {
        setError({
          priority_amount: "",
        });
      }, 5000);
      return true;
    } else {
      return false;
    }
  };

  const editBeneficiary = (key, value) => {
    if (key === "priority") {
      validateBeneficiaryAmount(value);
    }

    try {
      // console.log(key);
      // return;
      setBeneficiary((prev) => {
        return { ...prev, [key]: value };
      });
    } catch (e) {
      console.log(e);
    }
  };

  const trimNameField = (value) => {
    const name = value.trim();
    setBeneficiary({ ...beneficiary, ["name"]: name });
  };

  /*
    Counted, not set directly -- the same lock <OnProgress> takes while this
    saves. Setting `documentElement.style.overflow` here instead meant
    OnProgress captured "hidden" as the value to put BACK, so when the save
    finished and this popup closed itself, the restore handed the page
    "hidden" and it could no longer scroll. Reopening and closing without
    saving cleared it, which is what made it look intermittent.
  */
  useScrollLock(!userData.isFreezed);

  const clearNameError = () => {
    setDuplicatedName(false);
  };
  const emailField = (
    <div>
      {/*
        One field, two labels. A minor is written to through a guardian, but it
        is the same address in the same place doing the same job — so the record
        keeps one `email`, and only what the form calls it changes.
      */}
      <div className={`${styles.input_title} ${styles.required_field}`}>
        {minor ? content.newBeneficiaryText48 : content.newBeneficiaryText20}
      </div>
      <input
        value={beneficiary.email}
        onChange={(e) => editBeneficiary("email", e.target.value.toLowerCase())}
        className={`${styles.beneficiary_input} ${
          error.email ? styles.input_error : ""
        }`}
        placeholder="Email"
      ></input>
      <div className={styles.error_message}>
        {error.email ? error.email : null}
      </div>
      <div className={styles.choice}>
        <InfoTitle
          message={
            minor ? content.newBeneficiaryText51 : content.newBeneficiaryText21
          }
          title={
            minor ? content.newBeneficiaryText50 : content.newBeneficiaryText22
          }
          type={"small"}
        />
        <div
          disabled={userData.isFreezed || auth.awareness_email >= 12}
          className={styles.choice_container}
        >
          <span className={styles.switch_option}>
            {dublicatedcontent?.dublicatedText102}
          </span>
          <div className={styles.switch_toggle}>
            <Switch
              checked={beneficiary.awareness_status === "true"}
              onClick={() =>
                setBeneficiary({
                  ...beneficiary,
                  awareness_status:
                    beneficiary.awareness_status === "true" ? "false" : "true",
                })
              }
            />
          </div>
          <span
            className={styles.switch_option}
            style={{ marginRight: "10px" }}
          >
            {content.newBeneficiaryText23}
          </span>
        </div>
      </div>
      {auth.awareness_email >= 12 && (
        <div className={styles.error_message}>
          {"You reached the max amount of email per session"}
        </div>
      )}
    </div>
  );

  /*
    "Identified information".

    The relationship is asked of every beneficiary — an adult sister is a sister
    — so this section is always drawn. The date of birth beside it is the
    MINOR's, and only a minor has one; an adult's is the field further down,
    which is where it has always been.
  */
  const identifiedInformation = (
    <>
      <div className={styles.delay_period} style={{ margin: "20px 0 10px" }}>
        <div className={styles.bold_title}>{content.newBeneficiaryText29}</div>
      </div>
      <div className={styles.main_data_upper}>
        <div className={styles.upper_left}>
          <div className={styles.priority_level}>
            <div className={styles.input_title}>
              {content.newBeneficiaryText44}
            </div>
            <Info message={content.newBeneficiaryText45} />
          </div>
          <select
            value={beneficiary.relationship}
            onChange={(e) => editBeneficiary("relationship", e.target.value)}
            className={styles.select}
          >
            {/* Nothing chosen yet is a state of its own, not "Spouse". */}
            <option value="">{content.newBeneficiaryText52}</option>
            {RELATIONSHIP_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {websiteCurrentLang?.label === "fr" ? option.fr : option.en}
              </option>
            ))}
          </select>
          <div className={styles.error_message}>
            {error.relationship ? error.relationship : null}
          </div>
        </div>
        {/*
          The date of birth, whichever one applies: the minor's when the switch
          is on, the beneficiary's own when it is off. One slot rather than two,
          so the field does not move down the form as the switch is thrown — it
          is the same question either way, asked about a different person.

          They remain separate fields underneath, which is why the label, the
          value and the key it writes to all change together.
        */}
        <div className={styles.upper_right}>
          <div className={styles.delay_period}>
            <div className={`${styles.input_title} ${styles.required_field}`}>
              {minor
                ? content.newBeneficiaryText46
                : content.newBeneficiaryText30}
            </div>
            <Info
              type={error}
              message={
                minor
                  ? content?.newBeneficiaryText47
                  : content?.newBeneficiaryText31
              }
            />
          </div>
          <CCCalendar
            yyyy={dublicatedcontent?.yyyy}
            mm={dublicatedcontent?.mm}
            dd={dublicatedcontent?.dd}
            handleDate={(e) =>
              setBeneficiary({ ...beneficiary, birth_date: e })
            }
            parentDate_={beneficiary.birth_date}
            className={error.birth_date}
          />
          <div className={styles.error_message}>
            {error.birth_date ? error.birth_date : null}
          </div>
        </div>
      </div>
    </>
  );

  /*
    The switch that decides which set the form is showing. Off by default: a
    beneficiary is an adult unless the user says otherwise.
  */
  const minorToggle = (
    <div className={styles.choice} style={{ marginTop: "10px" }}>
      <InfoTitle
        message={content.newBeneficiaryText43}
        title={content.newBeneficiaryText42}
        type={"small"}
      />
      <div className={styles.choice_container}>
        <span className={styles.switch_option}>
          {dublicatedcontent?.dublicatedText102}
        </span>
        <div className={styles.switch_toggle}>
          <Switch
            checked={minor}
            onClick={() =>
              setBeneficiary({
                ...beneficiary,
                is_minor: minor ? "false" : "true",
              })
            }
          />
        </div>
        <span className={styles.switch_option} style={{ marginRight: "10px" }}>
          {content.newBeneficiaryText23}
        </span>
      </div>
    </div>
  );

  return (
    <>
      {!userData.isFreezed && (
        <div className={styles.background}>
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            style={
              width <= 599
                ? {
                    height: window.innerHeight - 10,
                  }
                : {}
            }
            className={styles.main_box}
          >
            <div
              onClick={() => {
                setBenefEmailFields([]);
                onClose();
              }}
              className={styles.close_logo}
            ></div>
            <div className={styles.title}>{content.newBeneficiaryText5}</div>
            <div
              className={styles.popup_scrollable}
              id="scrollContainer"
              ref={divElementRef}
            >
              <div
                className={`${styles.shadow_top} ${
                  showTopShadow ? styles.active : ""
                }`}
              />
              <div className={styles.main_data}>
                <div className={styles.main_data_upper}>
                  <div className={styles.upper_left}>
                    <div>
                      <div className={styles.priority_level}>
                        <div
                          className={`${styles.input_title} ${styles.required_field}`}
                        >
                          {content.newBeneficiaryText6}
                        </div>
                        <Info message={content.newBeneficiaryText7} />
                      </div>
                      <input
                        onClick={(e) => clearNameError()}
                        onBlur={(e) => trimNameField(e.target.value)}
                        value={beneficiary.name}
                        onChange={(e) =>
                          editBeneficiary("name", e.target.value)
                        }
                        className={`${styles.beneficiary_input} ${
                          error.name ? styles.input_error : ""
                        } ${duplicatedName ? styles.input_error : ""}`}
                        placeholder={content.newBeneficiaryText6}
                      ></input>
                      {duplicatedName ? (
                        <div className={styles.error_message}>
                          {duplicateError}
                        </div>
                      ) : null}
                      <div className={styles.error_message}>
                        {error.name ? error.name : null}
                      </div>
                    </div>
                    <div>
                      <div className={styles.priority_level}>
                        <div
                          className={`${styles.input_title} ${styles.required_field}`}
                        >
                          {content.newBeneficiaryText8}
                        </div>
                        <Info message={content.newBeneficiaryText9} />
                      </div>
                      <select
                        defaultValue={String(beneficiary.priority)}
                        onChange={(e) =>
                          editBeneficiary("priority", e.target.value)
                        }
                        className={styles.select}
                      >
                        {priorityOneAmount.length < 6 && (
                          <option value="1">
                            {content.newBeneficiaryText10}
                          </option>
                        )}
                        {priorityTwoAmount.length < 6 && (
                          <option value="2">
                            {content.newBeneficiaryText11}
                          </option>
                        )}
                      </select>
                      <div className={styles.error_message}>
                        {error.priority ? error.priority : null}
                      </div>
                    </div>
                  </div>
                  <div
                    className={styles.upper_right}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transform: "translateY(33px)",
                    }}
                  >
                    {width > 590 && (
                      <div
                        className={
                          String(beneficiary.priority) === "1"
                            ? `${styles.blue_image} ${styles.uploadPictureContainer}`
                            : `${styles.lighter_blue_image} ${styles.uploadPictureContainer}`
                        }
                      >
                        <div className={styles.upload_button_container}>
                          <div className={styles.upload_button}>
                            <div className={styles.upload_button}>
                              {!previewImage && (
                                <img
                                  src={uploadButton}
                                  alt="upload button"
                                  // style={{
                                  //   width: "102%",
                                  //   height: "102%",
                                  //   transform: "translateY(-2px)",
                                  // }}
                                  style={{
                                    width: "115px",
                                    height: "115px",
                                    transform: "translate(-2px,-2px)",
                                  }}
                                />
                              )}

                              <CropperImage
                                dragMode="move"
                                rotatable={true}
                                zoomSlider={false}
                                zoomOnTouch={false}
                                wheelZoomRatio={0.2}
                                zoomOnWheel={true}
                                modalTitle={dublicatedcontent?.edit_image}
                                quality={0.4}
                                classNames={"xxx"}
                                scalable={true}
                                cropShape="round"
                                restore={true}
                              >
                                <UploadProfilePicture
                                  multiple={false}
                                  maxCount={1}
                                  accept=".jpg, .jpeg, .png"
                                  beforeUpload={(file) => {
                                    const reader = new FileReader();
                                    reader.readAsDataURL(file);
                                    setImage(file);
                                    reader.onload = (e) => {
                                      setPreviewImage(reader.result);
                                    };

                                    // Prevent upload
                                    return false;
                                  }}
                                  itemRender={(
                                    originNode,
                                    file,
                                    fileList,
                                    { remove }
                                  ) => {
                                    return (
                                      <div
                                        className={styles.previewImageContainer}
                                      >
                                        {previewImage && (
                                          <>
                                            <img
                                              src={previewImage}
                                              alt="benef. "
                                              className={styles.previewImage}
                                            />

                                            <div
                                              className={
                                                styles.displayDeleteIcon
                                              }
                                            >
                                              <div
                                                className={styles.deletBackdrop}
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                  left: "0px",
                                                  top: "0",
                                                }}
                                              />
                                              <div
                                                className={styles.deleteIcon}
                                                onClick={(e) => {
                                                  remove(file);
                                                  setImage(null);
                                                  setPreviewImage(null);
                                                }}
                                              >
                                                <DeleteOutlined />
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    );
                                  }}
                                >
                                  <div className={styles.upload_trigger}>
                                    {!previewImage && (
                                      <p
                                        className={styles.uploadText}
                                        style={
                                          localStorage.getItem("language") ===
                                          "fr"
                                            ? {
                                                marginTop: "30px",
                                                marginRight: "5px",
                                                width: "110px",
                                              }
                                            : {
                                                marginTop: "20px",
                                                marginRight: "10px",
                                                width: "110px",
                                              }
                                        }
                                      >
                                        {content.newBeneficiaryText41}
                                      </p>
                                    )}

                                    {previewImage && (
                                      <img
                                        style={{ zIndex: 3 }}
                                        className={styles.editButton}
                                        src={editButton}
                                        alt="edit"
                                      />
                                    )}
                                  </div>
                                </UploadProfilePicture>
                              </CropperImage>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {width <= 590 && (
                  <div
                    className={
                      String(beneficiary.priority) === "1"
                        ? `${styles.blue_image} ${styles.uploadPictureContainer}`
                        : `${styles.lighter_blue_image} ${styles.uploadPictureContainer}`
                    }
                  >
                    <div className={styles.upload_button_container}>
                      <div className={styles.upload_button}>
                        <div className={styles.upload_button}>
                          {!previewImage && (
                            <img
                              src={uploadButton}
                              alt="upload button"
                              style={{
                                width: "125px",
                                height: "125px",
                                transform: "translate(-2px,-2px)",
                              }}
                            />
                          )}
                          <CropperImage
                            dragMode="move"
                            rotatable={true}
                            zoomSlider={false}
                            zoomOnTouch={false}
                            wheelZoomRatio={0.2}
                            zoomOnWheel={true}
                            modalTitle={dublicatedcontent?.edit_image}
                            quality={0.4}
                            classNames={"xxx"}
                            scalable={true}
                            cropShape="round"
                            restore={true}
                          >
                            <UploadProfilePicture
                              multiple={false}
                              maxCount={1}
                              accept=".jpg, .jpeg, .png"
                              beforeUpload={(file) => {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                setImage(file);
                                reader.onload = (e) => {
                                  setPreviewImage(reader.result);
                                };

                                // Prevent upload
                                return false;
                              }}
                              itemRender={(
                                originNode,
                                file,
                                fileList,
                                { remove }
                              ) => {
                                return (
                                  <div
                                    className={styles.previewImageContainer}
                                    style={{
                                      left: "5px",
                                      top: "1px",
                                    }}
                                  >
                                    {previewImage && (
                                      <>
                                        <img
                                          src={previewImage}
                                          alt="benef. "
                                          className={styles.previewImage}
                                        />

                                        <div
                                          className={styles.displayDeleteIcon}
                                        >
                                          <div
                                            className={styles.deletBackdrop}
                                          />
                                          <div
                                            className={styles.deleteIcon}
                                            onClick={(e) => {
                                              remove(file);
                                              setImage(null);
                                              setPreviewImage(null);
                                            }}
                                          >
                                            <DeleteOutlined />
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                );
                              }}
                            >
                              <div className={styles.upload_trigger}>
                                {!previewImage && (
                                  <p
                                    className={styles.uploadText}
                                    style={
                                      localStorage.getItem("language") === "fr"
                                        ? {
                                            width: "100px",
                                          }
                                        : {}
                                    }
                                  >
                                    {content.newBeneficiaryText41}
                                  </p>
                                )}

                                {previewImage && (
                                  <img
                                    className={styles.editButton}
                                    src={editButton}
                                    style={{
                                      right: "10px",
                                      bottom: "15px",
                                      zIndex: "5",
                                    }}
                                    alt="edit"
                                  />
                                )}
                              </div>
                            </UploadProfilePicture>
                          </CropperImage>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className={styles.error_message}>
                  {error.priority_amount ? error.priority_amount : null}
                </div>
              </div>
              {/*
                The minor switch sits in a row of its own, not in the column above.

                `.uploadPictureContainer` is `height: 100%` of `.upper_right`, which
                stretches to whatever the row's tallest column is — so anything added to
                the left column makes the profile picture TALLER WITHOUT MAKING IT WIDER,
                and the circle becomes an ellipse. Measured: the switch added 24px to the
                column and 24px to the picture's height, nothing to its width.

                Below the row it reads as the design draws it — directly under Priority
                Level, across the left half — and the picture keeps its shape.
              */}
              <div className={styles.main_data_upper}>
                <div className={styles.upper_left}>{minorToggle}</div>
              </div>
              {identifiedInformation}
              <div
                className={styles.delay_period}
                style={{ margin: "20px 0 10px" }}
              >
                <div className={styles.bold_title}>
                  {content.newBeneficiaryText18}
                </div>
                <Info message={content.newBeneficiaryText19} />
              </div>
              <div className={styles.main_data_upper}>
                <div className={styles.upper_left}>
                  {emailField}
                  {benefEmailFields?.map((emailField, i) => {
                    return (
                      <NewEmailField
                        dublicatedcontent={dublicatedcontent}
                        key={i}
                        setBeneficiary={setBeneficiary}
                        beneficiary={beneficiary}
                        error={error}
                        benefEmailFields={benefEmailFields}
                        setBenefEmailFields={setBenefEmailFields}
                        content={content}
                        id={emailField.id}
                        editBeneficiary={editBeneficiary}
                        minor={minor}
                      />
                    );
                  })}

                  {benefEmailFields.length < 2 && (
                    <div
                      className={styles.addEmail}
                      onClick={() => {
                        // setBenefEmailFields((prev) => [
                        //   ...prev,
                        //   handleAddBenefEmailField(prev.length),
                        // ]);

                        setBenefEmailFields((prev) => {
                          return [
                            ...prev,
                            {
                              new: true,
                              id: Math.random(0).toFixed(4),
                              email: "",
                            },
                          ];
                        });
                      }}
                    >
                      <img src={plus_button} alt="plus" />
                      <p>
                        {minor
                          ? dublicatedcontent?.add_another_guardian_email_address
                          : dublicatedcontent?.add_another_beneficiary_email_address}
                      </p>
                    </div>
                  )}
                </div>
                <div className={styles.upper_right}>
                  <div className={styles.input_title}>
                    {minor
                      ? content.newBeneficiaryText49
                      : content.newBeneficiaryText25}
                  </div>

                  <div className={styles.phone_div}>
                    <PhoneInput
                      localization={
                        websiteCurrentLang?.label === "fr"
                          ? fr_phone_countries
                          : undefined
                      }
                      country={websiteCurrentLang?.label === "fr" ? "fr" : "us"}
                      placeholder="Phone number"
                      onChange={(e) => editBeneficiary("phone_number", e)}
                    />
                  </div>
                  <div className={styles.error_message}>
                    {error.phone_number ? error.phone_number : null}
                  </div>
                </div>
              </div>
              {/* new design for personal message */}{" "}
              <div
                className={styles.input_title}
                style={{
                  marginTop: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <p> {content.newBeneficiaryText12}</p>
                {openPersonalMessage && (
                  <span
                    onClick={(e) => {
                      setOpenPersonalMessage(false);
                    }}
                    style={{
                      textDecoration: "underline",
                      color: "var(--color_blue)",
                      fontWeight: "400",
                      cursor: "pointer",
                    }}
                  >
                    {dublicatedcontent?.hide}
                  </span>
                )}
              </div>
              {!openPersonalMessage && (
                <div
                  onClick={() => {
                    setOpenPersonalMessage(true);
                  }}
                  className={styles.personalMessageTrigger}
                >
                  <p className={styles.personalMessageTriggerText}>
                    {dublicatedcontent.dublicatedText234}
                  </p>
                  <DownOutlined />
                </div>
              )}
              {openPersonalMessage && (
                <div className={styles.personalMessageContainer}>
                  <div className={styles.main_data_lower}>
                    <textarea
                      maxlength={maxMessageLength}
                      value={beneficiary.message}
                      ref={textareaRef}
                      placeholder={dublicatedcontent.dublicatedText233}
                      onChange={(e) => {
                        editBeneficiary("message", e.target.value);
                        handleChangeDescription(e);
                      }}
                      className={styles.large_message}
                      style={{
                        marginTop: 0,
                        backgroundColor: "white",
                      }}
                    ></textarea>
                    <div className={styles.error_message}>
                      {error.message ? error.message : null}
                    </div>
                    <div
                      className={`${styles.file_counter} ${
                        beneficiary.message.length === maxMessageLength
                          ? styles.error_text
                          : ""
                      }`}
                    >
                      {beneficiary.message.length === maxMessageLength ? (
                        <>{content.newBeneficiaryText13} </>
                      ) : (
                        ""
                      )}
                      {beneficiary.message.length}/{maxMessageLength}{" "}
                      {dublicatedcontent.dublicatedText93}
                    </div>
                  </div>
                  <div className={styles.upload_doc}>
                    <div className={styles.delay_period}>
                      <div className={styles.bold_title}>
                        {content.newBeneficiaryText14}
                      </div>
                      <Info message={content.newBeneficiaryText15} />
                    </div>
                    <div
                      className={`${styles.input_title} ${styles.grey_text}`}
                    >
                      {content.newBeneficiaryText16}
                    </div>
                    <div className={styles.file_container}>
                      {beneficiary.personal_documents.map((file) => {
                        return (
                          <FileIcon
                            key={file.id}
                            filename={file.name}
                            date={file.lastModified}
                            size={file.size}
                            OnDelete={() => deleteFile(file)}
                            OnClick={() =>
                              downloadLocalFile(
                                files.filter(
                                  (file_) => file_.name === file.id
                                )[0],
                                file.name
                              )
                            }
                          ></FileIcon>
                        );
                      })}
                      {/*
                        Not offered when a partner is creating for a customer:
                        files upload against the session, so these would land in
                        the PARTNER's storage and the customer would never see
                        them. They can add documents once they have approved.
                      */}
                      {beneficiary.personal_documents.length <=
                        maxFilesToUpload - 1 &&
                        !userData.partnerCreate && (
                          <Upload
                            handleFile={(e) => handleFile(e)}
                            clearField={needToClear}
                          />
                        )}
                    </div>
                    <div className={styles.error_message}>
                      {error.personal_documents
                        ? error.personal_documents
                        : null}
                    </div>
                    <div className={styles.file_counter}>
                      {content.newBeneficiaryText17}
                      <div
                        className={`${
                          beneficiary.personal_documents.length >=
                          maxFilesToUpload
                            ? styles.error_text
                            : ""
                        }`}
                      >
                        {beneficiary.personal_documents.length}/
                        {maxFilesToUpload} {dublicatedcontent.dublicatedText94}
                      </div>
                    </div>
                    {error.file_size ? (
                      <div
                        className={`${styles.error_message} ${styles.file_error}`}
                      >
                        {error.file_size}
                      </div>
                    ) : null}
                  </div>
                </div>
              )}
              <div style={{ position: "relative" }}>
                <div
                  className={styles.delay_period}
                  style={{ marginTop: "20px" }}
                >
                  <div className={styles.bold_title}>
                    {content.newBeneficiaryText33}
                  </div>
                  <Info message={content.newBeneficiaryText34} />
                  <div
                    onClick={() =>
                      setBeneficiary({
                        ...beneficiary,
                        visible_assets: userData.UserData.assets.map((e) => {
                          return e.asset_id;
                        }),
                      })
                    }
                    className={styles.blue_link}
                  >
                    {content.newBeneficiaryText35}
                  </div>

                  <div className={styles.assets_counter}>
                    <span className={styles.assets_selected}>
                      {beneficiary?.visible_assets.length}
                    </span>
                    /{userData.UserData.assets.length}{" "}
                    {content.newBeneficiaryText36}
                  </div>
                </div>
                <div className={styles.assets_div}>
                  <div className={styles.assets_container}>
                    {width > 590 && (
                      <AddNewAsset
                        alreadySelected={beneficiary.visible_assets}
                        assets={userData.UserData.assets}
                        onClick={(asset) =>
                          editBeneficiary("visible_assets", [
                            ...beneficiary.visible_assets,
                            asset.asset_id,
                          ])
                        }
                      />
                    )}
                    {beneficiary?.visible_assets?.map((asset_id) => {
                      let asset_types;
                      userData.UserData.assets.map((asset) => {
                        if (asset.asset_id === asset_id)
                          asset_types = (
                            <AssetType
                              asset_type={asset.asset_type}
                              asset_name={asset.asset_name}
                              onDelete={() =>
                                editBeneficiary(
                                  "visible_assets",
                                  beneficiary.visible_assets.filter(
                                    (e) => e !== asset.asset_id
                                  )
                                )
                              }
                            />
                          );
                        return null;
                      });
                      return asset_types;
                    })}
                    {width <= 590 && (
                      <AddNewAsset
                        alreadySelected={beneficiary.visible_assets}
                        assets={userData.UserData.assets}
                        onClick={(asset) =>
                          editBeneficiary("visible_assets", [
                            ...beneficiary.visible_assets,
                            asset.asset_id,
                          ])
                        }
                      />
                    )}
                  </div>
                </div>

                <div
                  className={styles.delay_period}
                  style={{ marginTop: "20px" }}
                >
                  <div className={styles.bold_title}>
                    {dublicatedcontent?.dublicatedText64}
                  </div>
                  <Info
                    position={"top"}
                    message={content.newBeneficiaryText37}
                  />
                </div>
                <div className={styles.file_container}>
                  {beneficiary.trustees.map((trustee_id) => {
                    let trustee_logo;
                    userData.UserData.trustees.map((trustee, i) => {
                      if (trustee_id === trustee.user_id)
                        trustee_logo = (
                          <Beneficiarytrustee
                            key={i}
                            name={trustee.name}
                            priority={0}
                            deleatable={true}
                            onDelete={() =>
                              editBeneficiary(
                                "trustees",
                                beneficiary.trustees.filter(
                                  (e) => e !== trustee.user_id
                                )
                              )
                            }
                          />
                        );
                      return null;
                    });
                    return trustee_logo;
                  })}
                  {beneficiary?.trustees.length <= 24 && (
                    <AddBeneficiary
                      specialStyle={true}
                      setShow={() => null}
                      alreadySelected={beneficiary.trustees}
                      user_type={"trustees"}
                      onSelect={(e) =>
                        editBeneficiary("trustees", [
                          ...beneficiary.trustees,
                          e.user_id,
                        ])
                      }
                    />
                  )}
                </div>
              </div>
              {partner && (
                <PartnerSharingPerson
                  subject="beneficiary"
                  value={personSharingValue(beneficiary)}
                  onChange={(next) =>
                    setBeneficiary((current) => ({ ...current, ...next }))
                  }
                  disabled={userData.isFreezed}
                  partnerName={partner.name}
                />
              )}
              <div className={styles.delay_period} style={{ display: "none" }}>
                <div className={styles.bold_title}>
                  {content.newBeneficiaryText38}
                </div>
                <Info message={content.newBeneficiaryText38} />
              </div>
              <div
                className={`${styles.shadow_bottom} ${
                  showBottomShadow ? styles.active : ""
                }`}
              />
              {/* <NewBeneficiaryCode code={beneficiary.personal_code} /> */}
            </div>

            <div className={styles.actions_toolbar}>
              <div onClick={() => onClose()} className={styles.cancel_button}>
                {content.newBeneficiaryText39}
              </div>
              <div
                onClick={(e) => handleSave(e)}
                className={styles.save_button}
              >
                {content.newBeneficiaryText40}
              </div>
            </div>
            {modal ? (
              <div style={{ position: "relative", zIndex: "2" }}>{modal}</div>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
}

export default NewBeneficiary;
